<template>
  <validation-observer v-slot="{ passes, handleSubmit }">
    <b-modal
      id="invitation-create-modal"
      size="sm"
      @ok.prevent="passes(() => createInvitation())"
    >
      <h6 slot="modal-header" class="modal-title">
        Account invitation
      </h6>

      <b-form role="form" @submit.prevent="handleSubmit(createInvitation)">
        <base-input
          alternative
          class="mb-3"
          name="Email"
          :rules="{ required: true, email: true }"
          :debounce="500"
          prepend-icon="ni ni-email-83"
          placeholder="Email address"
          v-model="model.email"
        ></base-input>

        <base-input
          label="Role"
          name="Role"
          :rules="{ oneOf: 'viewer,manager,owner' }"
          v-model="model.role"
        >
          <select class="form-control">
            <!-- TODO: allow specific options depending on account membership -->
            <option value="viewer">Viewer (read-only)</option>
            <option value="manager">Manager</option>
            <option value="owner">Owner</option>
          </select>
        </base-input>
      </b-form>

      <span slot="modal-ok">
        <span v-if="!creating">
          Send invitation <i class="fa fa-paper-plane ml-2"></i>
        </span>
        <span v-else>
          <i class="fa fa-spin fa-spinner mr-2"></i> Please wait&hellip;
        </span>
      </span>
    </b-modal>
  </validation-observer>
</template>

<script>
import { BaseAlert } from "@/components";
import { get } from "dot-prop";

export default {
  name: "invitation-create-form",
  props: {
    accountId: {
      type: String,
      required: true
    }
  },
  components: {
    BaseAlert
  },
  data() {
    return {
      model: {
        email: null,
        role: "manager"
      },
      creating: false
    };
  },
  methods: {
    createInvitation() {
      this.creating = true;
      const requestBody = {
        emailAddress: this.model.email,
        role: this.model.role
      };

      this.axios
        .post(`/v1/accounts/${this.accountId}/invitations`, requestBody)
        .then(response => {
          this.creating = false;
          if (response.data) {
            const invitation = response.data;
            this.$emit("create-invitation", invitation);
          }

          // notify (invitation sent)
          this.$notify({
            message: "Invitation sent",
            timeout: 3000,
            icon: "fa fa-paper-plane",
            type: "success"
          });

          // close modal
          this.$nextTick(() => {
            this.$bvModal.hide("invitation-create-modal");
          });
        })
        .catch(error => {
          this.creating = false;
          this.errorMessage = "Failed to create account";
          if (get(error, "response.data.message")) {
            this.errorMessage = error.response.data.message;
          }
        });
    }
  }
};
</script>
